export const getInitialValues = activePerson => {
  return {
    firstname: activePerson.firstname || "",
    lastname: activePerson.lastname || "",
    email: activePerson.email || "",
    civicRegistrationNumber: activePerson.civicRegistrationNumber || "",
    phoneNumbers: activePerson.phonenumbers.map(p => ({
      type: p.type || "",
      number: p.number || ""
    })),
    addresses:
      activePerson.addresses.length > 0
        ? activePerson.addresses.map(a => ({
            extra: a.extra || "",
            street: a.street || "",
            streetNumber: a.streetNumber || "",
            zipCode: a.zipCode || "",
            city: a.city || "",
            countryCode: a.countryCode || ""
          }))
        : [
            {
              extra: "",
              street: "",
              streetNumber: "",
              zipCode: "",
              city: "",
              countryCode: ""
            }
          ]
  };
};
